export default __webpack_public_path__ + "static/media/ed2mit2021tuto_A04.01-data-protection-compliance-v01.54074620.pdf";